import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import AtomicMathLayers from '~/landing/components/AtomicMathLayers'
import AtomicMathLayersMobile from '~/landing/components/AtomicMathLayersMobile'
import BgPattern from '~/landing/components/BgPattern'
import { Breakpoint, useCheckBreakpoint } from '~/utils/useBreakpoint'
import { useLandingEntryRoute } from '~/landing/contexts/landingEntryRoute'
import StartAnalytics from '~/analytics/start/startAnalytics'
import Button from '~/components/Buttons/Button'

export default function AtomicMath({
  buttonClassName,
  onClick,
}: {
  buttonClassName?: string
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
}): React.ReactElement {
  const { t } = useTranslation('landing')
  const entryRoute = useLandingEntryRoute()
  const isDesktop = useCheckBreakpoint({ gt: Breakpoint.LG })

  const handleButtonClick = (): void => {
    StartAnalytics.logCtaClick('onboarding_cta', 'landing_section_6_cta')
  }

  return (
    <div className="relative bg-gradient-to-t from-purple-indigo to-purple-plum">
      <BgPattern />
      <ResponsiveImage
        className="absolute min-w-196 w-full max-w-302 rotate-180 -ml-[400px] mt-44"
        height={886}
        imageClassName="object-contain"
        srcKey="landing/pad-pattern.png"
        width={1378}
      />
      <div className="w-screen flex flex-col justify-center items-center py-12 text-center text-white overflow-hidden relative z-10">
        <h1 className="text-6 md:text-h1 font-bold max-w-screen-19/20 md:max-w-250 leading-tight">
          {t('atomicMath.atomicMath')}
        </h1>
        <p className="text-md text-blue-pastel py-4 max-w-150 px-2">{t('atomicMath.smallestParrt')}</p>
        {isDesktop ? <AtomicMathLayers /> : <AtomicMathLayersMobile />}
        <div className="flex flex-wrap justify-center items-start mt-8 gap-8 md:gap-16 text-left w-full md:text-md mx-auto">
          <p className="max-w-72">{t('atomicMath.teachMath')}</p>
          <div className="max-w-72 w-full">
            <p>{t('atomicMath.allVideos')}</p>
            <ul className="list-disc list-inside -mr-5">
              <li className="ml-auto">{t('atomicMath.mathEducators')}</li>
              <li className="ml-auto">{t('atomicMath.notAI')}</li>
              <li className="ml-auto">{t('atomicMath.curriculum')}</li>
            </ul>
          </div>
          <p className="max-w-72 font-bold">{t('atomicMath.removesGuesswork')}</p>
        </div>
        <Button
          className={
            buttonClassName ||
            '!bg-green-lime !text-black border-4 rounded-full mt-4 px-8 py-2 text-md !font-black hover:scale-110 duration-100 z-10'
          }
          href={onClick ? undefined : entryRoute}
          onClick={onClick || handleButtonClick}
        >
          {t('testimonials.turnStruggle')}
        </Button>
      </div>
    </div>
  )
}
